import React, { useId } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { facetValue } from "./tableFeatures";
import { MenuPanel, MenuCheck } from "./MenuPanel";

/**
 * Multi-select filter for one column, with a live count per value taken from
 * the table's faceted row model (counts respect the other active filters).
 * Client-side only — the counts would lie on a server-paginated page.
 */
const FacetFilter = ({ column, label }) => {
  const id = useId();
  if (!column) return null;

  const selected = column.getFilterValue() || [];
  const counts = column.getFacetedUniqueValues();
  const values = Array.from(counts.keys())
    .map(facetValue)
    .filter((value) => value !== "")
    .sort((a, b) => a.localeCompare(b));

  const toggle = (value, checked) => {
    const next = checked
      ? [...selected, value]
      : selected.filter((item) => item !== value);
    column.setFilterValue(next.length ? next : undefined);
  };

  return (
    <Dropdown autoClose="outside" className="dt-menu">
      <Dropdown.Toggle
        as="button"
        type="button"
        className="dt-btn"
        id={"dt-facet-" + column.id + id}
      >
        <i className="fa fa-filter" aria-hidden="true"></i>
        {label}
        {selected.length > 0 ? (
          <span className="dt-btn-count">{selected.length}</span>
        ) : null}
      </Dropdown.Toggle>
      <MenuPanel
        title="Filters"
        align="start"
        footer={
          selected.length > 0 ? (
            <button
              type="button"
              className="dt-menu-clear"
              onClick={() => column.setFilterValue(undefined)}
            >
              Clear
            </button>
          ) : null
        }
      >
        {values.length === 0 ? (
          <div className="dt-menu-empty">No values</div>
        ) : null}
        {values.map((value, index) => (
          <MenuCheck
            key={value}
            index={index}
            checked={selected.includes(value)}
            onChange={(event) => toggle(value, event.target.checked)}
            label={value}
            count={counts.get(value) ?? ""}
          />
        ))}
      </MenuPanel>
    </Dropdown>
  );
};

export default FacetFilter;
